var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext } from 'react';
import uniqBy from 'lodash/uniqBy';
import cloneDeep from 'lodash/cloneDeep';
import { createComponentModel, Disposable, MODELS, useXFlowApp } from '@antv/xflow';
import { TREE_ROOT_ID } from './constants';
import AppContext from '../../context';
export var NsTreePanelData;
(function (NsTreePanelData) {
    NsTreePanelData.id = 'TREE_PANEL_DATA';
})(NsTreePanelData || (NsTreePanelData = {}));
export var useTreePanelData = function (props) {
    var treeDataService = props.treeDataService, searchService = props.searchService;
    var modelService = useXFlowApp().modelService;
    var flowchartId = useContext(AppContext).flowchartId;
    /** 使用model */
    var _a = createComponentModel({
        treeData: [],
        searchList: [],
        treeNodeList: [],
        expandedKeys: [],
        defaultExpandAll: false,
        keyword: '',
    }), state = _a[0], setState = _a[1], panelModel = _a[2];
    /** 注册成为全局状态，方便其他组件联动 */
    React.useEffect(function () {
        if (modelService.findDeferredModel(NsTreePanelData.id)) {
            return;
        }
        modelService.registerModel({
            id: NsTreePanelData.id,
            modelFactory: function () { return panelModel; },
            watchChange: function (self) { return __awaiter(void 0, void 0, void 0, function () {
                var graphMetaModel, fetch, graphMetaDisposable;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MODELS.GRAPH_META.getModel(modelService)];
                        case 1:
                            graphMetaModel = _a.sent();
                            fetch = function (meta) { return __awaiter(void 0, void 0, void 0, function () {
                                var listData, _a, treeData, rootNodes, currentState, expandedKeys;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, treeDataService(meta, modelService, flowchartId)];
                                        case 1:
                                            listData = _b.sent();
                                            _a = NodeList2Tree(listData), treeData = _a.treeData, rootNodes = _a.rootNodes;
                                            return [4 /*yield*/, self.getValidValue()];
                                        case 2:
                                            currentState = _b.sent();
                                            expandedKeys = currentState.expandedKeys.length > 0 ? currentState.expandedKeys : rootNodes.map(function (i) { return i.id; });
                                            return [2 /*return*/, { listData: listData, treeData: treeData, expandedKeys: expandedKeys }];
                                    }
                                });
                            }); };
                            graphMetaDisposable = graphMetaModel.watch(function (meta) { return __awaiter(void 0, void 0, void 0, function () {
                                var data;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, fetch(meta)];
                                        case 1:
                                            data = _a.sent();
                                            self.setValue({
                                                treeNodeList: data.listData,
                                                treeData: data.treeData,
                                                expandedKeys: data.expandedKeys,
                                                defaultExpandAll: false,
                                                keyword: '',
                                                searchList: [],
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            return [2 /*return*/, Disposable.create(function () {
                                    graphMetaDisposable.dispose();
                                })];
                    }
                });
            }); },
        });
        /* eslint-disable-next-line  */
    }, []);
    /** 折叠文件夹 */
    var onFolderExpand = React.useCallback(function (expandedKeys) {
        debugger;
        setState(function (modelState) {
            modelState.expandedKeys = expandedKeys;
        });
    }, [setState]);
    /** 搜索 */
    var onKeywordChange = React.useCallback(function (keyword) { return __awaiter(void 0, void 0, void 0, function () {
        var list_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchService) {
                        return [2 /*return*/];
                    }
                    if (!keyword) return [3 /*break*/, 2];
                    return [4 /*yield*/, searchService(state.treeNodeList, keyword)];
                case 1:
                    list_1 = _a.sent();
                    setState(function (modelState) {
                        modelState.keyword = keyword;
                        modelState.searchList = list_1;
                    });
                    return [3 /*break*/, 3];
                case 2:
                    setState(function (modelState) {
                        modelState.keyword = '';
                        modelState.searchList = [];
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [searchService, state.treeNodeList, setState]);
    return {
        state: state,
        setState: setState,
        onKeywordChange: onKeywordChange,
        onFolderExpand: onFolderExpand,
    };
};
// 将list数据转换为树
export function NodeList2Tree(treeNodes) {
    if (treeNodes === void 0) { treeNodes = []; }
    var getGroupByIdMap = function (list) {
        var uniqList = uniqBy(list, 'id');
        var groups = uniqList.reduce(function (map, node) {
            var parentId = node.parentId || TREE_ROOT_ID;
            if (!map.has(parentId)) {
                map.set(parentId, []);
            }
            var group = map.get(parentId);
            group === null || group === void 0 ? void 0 : group.push(node);
            return map;
        }, new Map());
        return groups;
    };
    var groupMap = getGroupByIdMap(cloneDeep(treeNodes));
    function iterator(nodes, groupMapArgs) {
        return nodes.map(function (node) {
            if (groupMapArgs.has(node.id)) {
                var children = groupMapArgs.get(node.id) || [];
                node.key = node.id;
                node.isDirectory = true;
                node.children = iterator(children, groupMapArgs) || [];
            }
            else {
                node.isLeaf = true;
            }
            return node;
        });
    }
    var rootNodes = groupMap.get(TREE_ROOT_ID) || [];
    var treeData = iterator(rootNodes, groupMap);
    return { treeData: treeData, rootNodes: rootNodes };
}
